import React, { useState, useEffect } from "react"
import { Col, Row, UncontrolledAlert, Spinner } from "reactstrap"
import api from "API/Api"
import { AvForm, AvField, AvRadioGroup, AvRadio } from "availity-reactstrap-validation"
import { Link, useParams } from "react-router-dom"

const EditCollection = () => {
  const { id } = useParams()
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [pageLoad, setPageLoad] = useState(true)
  const [center, setCenter] = useState(null)
  const [selectedPaymentMode, setSelectedPaymentMode] = useState("")
  const [companies, setCompanies] = useState([])
  const [plants, setPlants] = useState([])
  const [chCenters, setChCenters] = useState([])
  const [routes, setRoutes] = useState([])
  const [states, setStates] = useState([])
  const [districts, setDistricts] = useState([])
  const [taluks, setTaluks] = useState([])
  const [selectedCompany, setSelectedCompany] = useState("")
  const [selectedPlant, setSelectedPlant] = useState("")
  const [loadingCC, setLoadingCC] = useState(false)
  const [loadingRoutes, setLoadingRoutes] = useState(false)
  const [loadingDistricts, setLoadingDistricts] = useState(false)
  const [loadingTaluks, setLoadingTaluks] = useState(false)
  const [applicableMilk, setApplicableMilk] = useState({ cow: true, buffalo: true })
  const [selectedImage, setSelectedImage] = useState(null)
  const [selectedPanImage, setSelectedPanImage] = useState(null)
  const [selectedBankImage, setSelectedBankImage] = useState(null)

  useEffect(() => {
    const loadData = async () => {
      try {
        const [cResp, compResp, plantResp, stResp] = await Promise.all([
          api.get("collection-center/" + id),
          api.get("companies"), api.get("plants"), api.get("states")
        ])
        const cData = cResp.data.data?.[0] || cResp.data.data
        setCenter(cData)
        // Init payment mode from existing data
        setSelectedPaymentMode(String(cData.paymentMode || ""))
        const compData = Array.isArray(compResp.data.data) ? compResp.data.data : compResp.data.data?.data || []
        setCompanies(compData)
        const plantData = Array.isArray(plantResp.data.data) ? plantResp.data.data : plantResp.data.data?.data || []
        setPlants(plantData)
        setStates(Array.isArray(stResp.data.data) ? stResp.data.data : stResp.data.data?.data || [])

        // Parse applicable milk types
        if (cData.applicableMilkTypes) {
          const m = cData.applicableMilkTypes
          setApplicableMilk({ cow: m.includes("Cow"), buffalo: m.includes("Buffalo") })
        }

        // Derive plant & company from the CC that this VLCC belongs to
        if (cData.chillingCenter) {
          try {
            const ccResp = await api.get("center/" + cData.chillingCenter)
            const ccData = ccResp.data.data?.[0] || ccResp.data.data
            if (ccData && ccData.plant_id) {
              setSelectedPlant(String(ccData.plant_id))
              // Derive company from plant
              const plant = plantData.find(p => String(p.id) === String(ccData.plant_id))
              if (plant && plant.company_id) {
                setSelectedCompany(String(plant.company_id))
              } else if (compData.length === 1) {
                setSelectedCompany(String(compData[0].id))
              }
              // Load CCs for that plant
              const centersResp = await api.get("chillings-by-plant/" + ccData.plant_id)
              setChCenters(Array.isArray(centersResp.data.data) ? centersResp.data.data : centersResp.data.data?.data || [])
            }
          } catch (e) { console.error(e) }
        }

        // Load routes for the selected CC
        if (cData.chillingCenter) {
          try {
            const rtResp = await api.get("route-cc/" + cData.chillingCenter)
            setRoutes(Array.isArray(rtResp.data.data) ? rtResp.data.data : rtResp.data.data?.data || [])
          } catch (e) { console.error(e) }
        }

        // Load districts/taluks for address
        if (cData.state) {
          const dstResp = await api.get("districts/" + cData.state)
          setDistricts(Array.isArray(dstResp.data.data) ? dstResp.data.data : dstResp.data.data?.data || [])
          if (cData.district) {
            try { const tlkResp = await api.get("taluks/" + cData.district); setTaluks(Array.isArray(tlkResp.data.data) ? tlkResp.data.data : tlkResp.data.data?.data || []) } catch (e) {}
          }
        }
      } catch (e) { console.error(e) }
      setPageLoad(false)
    }
    loadData()
  }, [id])

  const handlePlantChange = async (plantId) => {
    setSelectedPlant(plantId)
    setChCenters([]); setRoutes([])
    if (!plantId) return
    setLoadingCC(true)
    try {
      const resp = await api.get("chillings-by-plant/" + plantId)
      setChCenters(Array.isArray(resp.data.data) ? resp.data.data : resp.data.data?.data || [])
    } catch (e) { console.error(e) }
    setLoadingCC(false)
  }

  const handleCCChange = async (ccId) => {
    setRoutes([])
    if (!ccId) return
    setLoadingRoutes(true)
    try {
      const resp = await api.get("route-cc/" + ccId)
      setRoutes(Array.isArray(resp.data.data) ? resp.data.data : resp.data.data?.data || [])
    } catch (e) { console.error(e) }
    setLoadingRoutes(false)
  }

  const stateChangeHandler = async e => {
    const stateId = e.target.value; setDistricts([]); setTaluks([])
    if (!stateId) return; setLoadingDistricts(true)
    try { const r = await api.get("districts/" + stateId); setDistricts(Array.isArray(r.data.data) ? r.data.data : r.data.data?.data || []) } catch (e) {}
    setLoadingDistricts(false)
  }
  const districtChangeHandler = async e => {
    const districtId = e.target.value; setTaluks([])
    if (!districtId) return; setLoadingTaluks(true)
    try { const r = await api.get("taluks/" + districtId); setTaluks(Array.isArray(r.data.data) ? r.data.data : r.data.data?.data || []) } catch (e) {}
    setLoadingTaluks(false)
  }

  const handleFileRead = (e, setter) => {
    const file = e.target.files[0]
    if (file) { const r = new FileReader(); r.onloadend = () => setter(r.result); r.readAsDataURL(file) }
    else setter(null)
  }

  const handleValidSubmit = async (event, values) => {
    setLoading(true)
    try {
      // Build applicable milk types
      const milkArr = []
      if (applicableMilk.cow) milkArr.push("Cow")
      if (applicableMilk.buffalo) milkArr.push("Buffalo")
      values.applicableMilkTypes = milkArr.join(",")
      values.adhaar_upload = selectedImage
      values.pan_upload = selectedPanImage
      values.bank_upload = selectedBankImage
      // Remove UI-only fields
      delete values.plant_filter
      delete values.company_filter
      const resp = await api.put("update-collection-center/" + id, values)
      if (resp.data.success) { setSubmitted(true); setTimeout(() => setSubmitted(false), 4000) }
    } catch (e) {
      console.error(e)
      alert(e.response?.data?.message || e.response?.data?.error || "Failed to update")
    }
    setLoading(false)
  }

  if (pageLoad) return <div className="dashBody"><div className="text-center py-5"><Spinner color="primary" style={{ width: "3rem", height: "3rem" }} /><p className="mt-3 text-muted">Loading Center...</p></div></div>
  if (!center) return <div className="dashBody"><p>Center not found</p></div>

  const hasMultiCompanies = companies.length > 1
  const filteredPlants = hasMultiCompanies && selectedCompany
    ? plants.filter(p => String(p.company_id) === selectedCompany)
    : plants

  return (
    <div className="dashBody">
      <div className="font-size-18 mb-0 dashHeader">
        <Row>
          <Col md={6}><h4>Edit Collection Center</h4></Col>
          <Col md={6} style={{ textAlign: "right" }}>
            <Link to="/collection-center-vlcc" className="dashBtn"><i className="fas fa-chevron-left"></i> <b>Back</b></Link>
          </Col>
        </Row>
      </div>
      <div className="dashContent">
        <AvForm className="form-horizontal mt-4" onValidSubmit={handleValidSubmit}>

          {/* Center Info */}
          <h6 style={{ color: "#6366f1", borderBottom: "2px solid #e2e8f0", paddingBottom: "8px", marginBottom: "16px" }}>
            <i className="fas fa-store-alt"></i> Center Information
          </h6>
          <Row>
            {hasMultiCompanies && (
              <Col md={3}><div className="mb-3">
                <AvField type="select" name="company_filter" label="Company *" value={selectedCompany}
                  onChange={e => { setSelectedCompany(e.target.value); setSelectedPlant(""); setChCenters([]); setRoutes([]) }}>
                  <option value="">Select Company</option>
                  {companies.map((c, i) => <option key={i} value={String(c.id)}>{c.name}</option>)}
                </AvField>
              </div></Col>
            )}
            <Col md={hasMultiCompanies ? 2 : 3}><div className="mb-3">
              <AvField type="select" name="plant_filter" label="Plant *" value={selectedPlant}
                onChange={e => handlePlantChange(e.target.value)}>
                <option value="">{hasMultiCompanies && !selectedCompany ? "Select Company first" : "Select"}</option>
                {filteredPlants.map((p, i) => <option key={i} value={String(p.id)}>{p.name}</option>)}
              </AvField>
            </div></Col>
            <Col md={hasMultiCompanies ? 2 : 3}><div className="mb-3">
              <AvField type="select" name="chillingCenter" label={<>Chilling Center * {loadingCC && <Spinner size="sm" color="primary" className="ms-1" />}</>} required
                value={String(center.chillingCenter || "")} onChange={e => handleCCChange(e.target.value)}>
                <option value="">{loadingCC ? "Loading..." : chCenters.length ? "Select" : "Select Plant first"}</option>
                {chCenters.map((c, i) => <option key={i} value={String(c.id)}>{c.name}{c.number ? ` (${c.number})` : ""}</option>)}
              </AvField>
            </div></Col>
            <Col md={hasMultiCompanies ? 2 : 3}><div className="mb-3">
              <AvField type="select" name="route" label={<>Route * {loadingRoutes && <Spinner size="sm" color="primary" className="ms-1" />}</>} required
                value={String(center.route || "")}>
                <option value="">{loadingRoutes ? "Loading..." : routes.length ? "Select" : "Select CC first"}</option>
                {routes.map((r, i) => <option key={i} value={String(r.id)}>{r.routeName}{r.routeNumber ? ` (${r.routeNumber})` : ""}</option>)}
              </AvField>
            </div></Col>
            <Col md={3}><div className="mb-3">
              <AvField type="select" name="operationType" label="Operation Type *" required value={center.operationType || ""}>
                <option value="">Select</option>
                <option value="Direct Company Center">Direct Company Center</option>
                <option value="Agent Center">Agent Center</option>
                <option value="Independent Center">Independent Center</option>
              </AvField>
            </div></Col>
          </Row>
          <Row>
            <Col md={4}><div className="mb-3"><AvField name="centerName" label="Center Name *" value={center.centerName} type="text" required /></div></Col>
            <Col md={4}><div className="mb-3"><AvField name="centerNumber" label="Center Number *" value={center.centerNumber} type="text" required /></div></Col>
            <Col md={4}><div className="mb-3"><AvField name="canNumber" label="Can Number" value={center.canNumber} type="text" /></div></Col>
          </Row>
          <Row>
            <Col md={6}><div className="mb-3">
              <AvRadioGroup inline name="virtualCenter" label="Is this VLCC a Virtual Center?" errorMessage="Pick one!" value={String(center.virtualCenter || "0")}>
                <AvRadio label="Yes" value="1" /><AvRadio label="No" value="0" />
              </AvRadioGroup>
            </div></Col>
          </Row>

          {/* Address */}
          <h6 style={{ color: "#0ea5e9", borderBottom: "2px solid #e2e8f0", paddingBottom: "8px", marginBottom: "16px", marginTop: "12px" }}>
            <i className="fas fa-map-marker-alt"></i> Address Details
          </h6>
          <Row>
            <Col md={4}><div className="mb-3"><AvField name="door" label="Door No" value={center.door} type="text" /></div></Col>
            <Col md={4}><div className="mb-3"><AvField name="village" label="Village Name" value={center.village} type="text" /></div></Col>
            <Col md={4}><div className="mb-3"><AvField name="taluk" label="Taluk Name" value={center.taluk} type="text" /></div></Col>
          </Row>
          <Row>
            <Col md={4}><div className="mb-3">
              <AvField type="select" name="state" label="State" value={String(center.state || "")} onChange={stateChangeHandler}>
                <option value="">Select State</option>
                {states.map((s, i) => <option key={i} value={String(s.id)}>{s.state}</option>)}
              </AvField>
            </div></Col>
            <Col md={4}><div className="mb-3">
              <AvField type="select" name="district" label={<>District {loadingDistricts && <Spinner size="sm" color="primary" className="ms-1" />}</>}
                value={String(center.district || "")} onChange={districtChangeHandler}>
                <option value="">{loadingDistricts ? "Loading..." : districts.length ? "Select District" : "Select State first"}</option>
                {districts.map((d, i) => <option key={i} value={String(d.id)}>{d.district}</option>)}
              </AvField>
            </div></Col>
            <Col md={4}><div className="mb-3">
              <AvField name="pincode" label="Pincode" value={center.pincode} type="text"
                validate={{ pattern: { value: /^[1-9][0-9]{5}$/, errorMessage: "Valid 6-digit pin" },
                  minLength: { value: 6, errorMessage: "6 digits" }, maxLength: { value: 6, errorMessage: "6 digits" } }} />
            </div></Col>
          </Row>

          {/* People */}
          <h6 style={{ color: "#22c55e", borderBottom: "2px solid #e2e8f0", paddingBottom: "8px", marginBottom: "16px", marginTop: "12px" }}>
            <i className="fas fa-user-tie"></i> People & Management
          </h6>
          <Row>
            <Col md={4}><div className="mb-3"><AvField name="inchargeName" label="Center Incharge Name" value={center.inchargeName} type="text" /></div></Col>
            <Col md={4}><div className="mb-3"><AvField name="inchargeMobile" label="Center Incharge Mobile" value={center.inchargeMobile} type="text" /></div></Col>
            <Col md={4}><div className="mb-3"><AvField name="inchargeEmail" label="Center Incharge Email" value={center.inchargeEmail} type="email" /></div></Col>
          </Row>
          <Row>
            <Col md={6}><div className="mb-3"><AvField name="inchargeAadhar" label="Center Incharge Aadhaar" value={center.inchargeAadhar} type="text" /></div></Col>
            <Col md={6}><div className="mb-3"><AvField name="inchargePAN" label="Center Incharge PAN" value={center.inchargePAN} type="text" /></div></Col>
          </Row>
          <Row>
            <Col md={4}><div className="mb-3"><AvField name="supervisor" label="Supervisor" value={center.supervisor} type="text" /></div></Col>
            <Col md={4}><div className="mb-3"><AvField name="secretaryName" label="Secretary Name" value={center.secretaryName} type="text" /></div></Col>
            <Col md={4}><div className="mb-3"><AvField name="secretaryMobile" label="Secretary Mobile" value={center.secretaryMobile} type="text" /></div></Col>
          </Row>
          <Row>
            <Col md={4}><div className="mb-3"><AvField name="presidentName" label="President Name" value={center.presidentName} type="text" /></div></Col>
            <Col md={4}><div className="mb-3"><AvField name="presidentMobile" label="President Mobile" value={center.presidentMobile} type="text" /></div></Col>
            <Col md={4}><div className="mb-3"><AvField name="remarks" label="Remarks" value={center.remarks} type="textarea" rows="2" /></div></Col>
          </Row>

          {/* Rate Chart & Settings */}
          <h6 style={{ color: "#f59e0b", borderBottom: "2px solid #e2e8f0", paddingBottom: "8px", marginBottom: "16px", marginTop: "12px" }}>
            <i className="fas fa-chart-line"></i> Rate Chart & Settings
          </h6>
          <Row>
            <Col md={4}><div className="mb-3">
              <AvRadioGroup inline name="rateChartType" label="Rate Chart Type *" required errorMessage="Pick one!" value={String(center.rateChartType || "")}>
                <AvRadio label="Common" value="0" /><AvRadio label="Separate" value="1" />
              </AvRadioGroup>
            </div></Col>
            <Col md={4}><div className="mb-3">
              <AvRadioGroup inline name="paymentMode" label="Payment Mode *" required errorMessage="Pick one!" value={String(center.paymentMode || "")} onChange={e => setSelectedPaymentMode(e.target.value)}>
                <AvRadio label="Cash" value="0" /><AvRadio label="Bank Account" value="1" />
              </AvRadioGroup>
            </div></Col>
          </Row>
          {selectedPaymentMode === "1" && (
            <Row>
              <Col md={4}><div className="mb-3">
                <AvField name="bankAccountNumber" label="Bank Account Number *" type="text" required value={center.bankAccountNumber || ""} placeholder="Enter Account Number" />
              </div></Col>
              <Col md={4}><div className="mb-3">
                <AvField name="bankAccountName" label="Bank Account Name *" type="text" required value={center.bankAccountName || ""} placeholder="Enter Account Name" />
              </div></Col>
              <Col md={4}><div className="mb-3">
                <AvRadioGroup inline name="bankAccountType" label="Bank Account Type *" required errorMessage="Pick one!" value={center.bankAccountType || ""}>
                  <AvRadio label="Savings" value="Savings" /><AvRadio label="Current" value="Current" />
                </AvRadioGroup>
              </div></Col>
            </Row>
          )}

          {/* Document Uploads */}
          <h6 style={{ color: "#ef4444", borderBottom: "2px solid #e2e8f0", paddingBottom: "8px", marginBottom: "16px", marginTop: "12px" }}>
            <i className="fas fa-file-upload"></i> Document Uploads
          </h6>
          <Row>
            <Col md={4}>
              <label className="form-label">Upload Aadhaar Copy</label>
              <input type="file" className="form-control" accept="image/*" onChange={e => handleFileRead(e, setSelectedImage)} />
              {selectedImage && <img src={selectedImage} alt="Aadhar" style={{ maxWidth: "150px", maxHeight: "100px", marginTop: "8px", borderRadius: "4px" }} />}
            </Col>
            <Col md={4}>
              <label className="form-label">Upload PAN Copy</label>
              <input type="file" className="form-control" accept="image/*" onChange={e => handleFileRead(e, setSelectedPanImage)} />
              {selectedPanImage && <img src={selectedPanImage} alt="PAN" style={{ maxWidth: "150px", maxHeight: "100px", marginTop: "8px", borderRadius: "4px" }} />}
            </Col>
            <Col md={4}>
              <label className="form-label">Upload Bank Passbook/Statement</label>
              <input type="file" className="form-control" accept="image/*" onChange={e => handleFileRead(e, setSelectedBankImage)} />
              {selectedBankImage && <img src={selectedBankImage} alt="Bank" style={{ maxWidth: "150px", maxHeight: "100px", marginTop: "8px", borderRadius: "4px" }} />}
            </Col>
          </Row>

          {/* CC Purchase Settings */}
          <h6 style={{ color: "#8b5cf6", borderBottom: "2px solid #e2e8f0", paddingBottom: "8px", marginBottom: "16px", marginTop: "20px" }}>
            <i className="fas fa-cogs"></i> CC Purchase Settings
          </h6>
          <Row>
            <Col md={6}><div className="mb-3">
              <AvRadioGroup inline name="agentCommissionCowMilk" label="Agent Commission Available for Cow Milk in CC Purchase?" errorMessage="Pick one!" value={String(center.agentCommissionCowMilk || "0")}>
                <AvRadio label="Yes" value="1" /><AvRadio label="No" value="0" />
              </AvRadioGroup>
            </div></Col>
            <Col md={6}><div className="mb-3">
              <AvRadioGroup inline name="agentCommissionBuffaloMilk" label="Agent Commission Available for Buffalo Milk in CC Purchase?" errorMessage="Pick one!" value={String(center.agentCommissionBuffaloMilk || "0")}>
                <AvRadio label="Yes" value="1" /><AvRadio label="No" value="0" />
              </AvRadioGroup>
            </div></Col>
          </Row>
          <Row>
            <Col md={6}><div className="mb-3">
              <AvField type="select" name="pickupVehicle" label="Pickup Vehicle" value={center.pickupVehicle || ""}>
                <option value="">Select</option>
                <option value="Auto">Auto</option>
                <option value="Van">Van</option>
                <option value="Truck">Truck</option>
                <option value="Bike">Bike</option>
                <option value="Other">Other</option>
              </AvField>
            </div></Col>
            <Col md={6}><div className="mb-3">
              <AvRadioGroup inline name="limitSingleEntryVendorCC" label="Limit Single Entry by Milk Type for this vendor in CC *" required errorMessage="Pick one!" value={String(center.limitSingleEntryVendorCC || "")}>
                <AvRadio label="Yes" value="1" /><AvRadio label="No" value="0" />
              </AvRadioGroup>
            </div></Col>
          </Row>
          <Row>
            <Col md={4}><div className="mb-3">
              <label className="form-label">Applicable Milk Types in CC *</label>
              <div style={{ display: "flex", gap: "16px", paddingTop: "6px" }}>
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" id="milkCow" checked={applicableMilk.cow}
                    onChange={e => setApplicableMilk(p => ({ ...p, cow: e.target.checked }))} />
                  <label className="form-check-label" htmlFor="milkCow">Cow</label>
                </div>
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" id="milkBuffalo" checked={applicableMilk.buffalo}
                    onChange={e => setApplicableMilk(p => ({ ...p, buffalo: e.target.checked }))} />
                  <label className="form-check-label" htmlFor="milkBuffalo">Buffalo</label>
                </div>
              </div>
            </div></Col>
            <Col md={4}><div className="mb-3">
              <AvRadioGroup inline name="defaultMilkTypeCC" label="Default Milk Type in CC" errorMessage="Pick one!" value={String(center.defaultMilkTypeCC || "0")}>
                <AvRadio label="Cow" value="1" /><AvRadio label="Buffalo" value="2" /><AvRadio label="None" value="0" />
              </AvRadioGroup>
            </div></Col>
            <Col md={4}><div className="mb-3">
              <AvRadioGroup inline name="sendSmsCcPurchases" label="Send SMS for CC Purchases *" required errorMessage="Pick one!" value={String(center.sendSmsCcPurchases || "")}>
                <AvRadio label="Yes" value="1" /><AvRadio label="No" value="0" />
              </AvRadioGroup>
            </div></Col>
          </Row>

          {/* Export */}
          <h6 style={{ color: "#64748b", borderBottom: "2px solid #e2e8f0", paddingBottom: "8px", marginBottom: "16px", marginTop: "12px" }}>
            <i className="fas fa-file-export"></i> Export Parameters
          </h6>
          <Row>
            <Col md={4}><div className="mb-3"><AvField name="parameter1" label="Export Parameter 1" value={center.parameter1} type="text" /></div></Col>
            <Col md={4}><div className="mb-3"><AvField name="parameter2" label="Export Parameter 2" value={center.parameter2} type="text" /></div></Col>
            <Col md={4}><div className="mb-3"><AvField name="parameter3" label="Export Parameter 3" value={center.parameter3} type="text" /></div></Col>
          </Row>

          <div className="mb-3 row mt-4">
            <div className="col-6">
              {submitted && <UncontrolledAlert color="success"><strong>Collection Center Updated!</strong></UncontrolledAlert>}
            </div>
            <div className="col-6 text-end">
              <button className="btn btn-primary w-md waves-effect waves-light" type="submit" disabled={loading}>
                {loading ? <><Spinner size="sm" /><span style={{ paddingLeft: "10px" }}>Updating...</span></> : <span><i className="fas fa-save"></i> Update Center</span>}
              </button>
            </div>
          </div>
        </AvForm>
      </div>
    </div>
  )
}

export default EditCollection
